import api from "@/services/api.service";
import { required } from "vuelidate/lib/validators";

export default {
  name: "edit",
  components: {},
  props: {},
  data() {
    return {
      caption: "Edit Export Contact Filter",
      vendors: [],
      formField: {
        tags: [],
        title: "",
        contact_values: {},
        marketing_event_id: "",
        type:""
      },
      submitStatus: null,
      filterCriteria: [{ columns: null, text_value: null }],
      map_headers: [],
      concateColumn: [{ name: null, columns: [null] }],
      selectedHeadersShow: [],
      checkedHeaders: [],
      existing_tags: [],
      tags: [],
      removed_tags: [],
      permission_edit: false,
      superAdmin:false
    };
  },
  computed: {},
  mounted() {},
  validations: {
    formField: {
      title: {
        required
      },
      type: {
        required
      },
      tags: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
            response.data[0].permission.forEach( function(element) {                
                permissions.push(element.action)
            }.bind(this));
            if(permissions.includes("edit_export_contact") == true){    
              this.getColumns();
              this.getTags();
              this.getExportedContact();
              this.permission_edit = permissions.includes("edit_export_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getColumns();
              this.getTags();
              this.getExportedContact();
              this.superAdmin = true;
            }else if(permissions.includes("list_export_contact") == true || permissions.includes("add_export_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Export Contact List'});
            } else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }      
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
          }.bind(this)
          );
      }
    },
    async getExportedContact() {
      let response = await api.post("admin/export-contact/list", { id: this.$route.params.id});
      if (!response)
        this.makeToast(  "Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data != "") {                   
          this.formField.title = response.data.title; 
          var contact_values = response.data.filter_criteria;          
          response.data.tags.forEach(
            function(e) {
              this.tags.push({ id: e.id, value: e.tags });
            }.bind(this)
            );

          this.filterCriteria = contact_values.filter_criteria;
          this.formField.type = contact_values.match_with;
          contact_values.selected_column.forEach(
            function(element) {
              this.checkedHeaders[element.value] = element.value;
              this.selectedHeadersShow.push({text: element.text,value: element.value});
            }.bind(this)
            );

          this.concateColumn = contact_values.concate_column;

          this.formField.tags = this.tags;
        } else {
          this.makeToast(`No vendor found.`, "Alert", "danger");
        }
      } else this.makeToast(`No vendor found.`, "Alert", "danger");
    },

    async getColumns() {

     var response = await  api.post('admin/mapping_headers/list')
     if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
    if (response.status == 'success') {
      if (response.data != '') {          
        response.data.data.forEach(function(e){                      
          this.map_headers.push({value:e.column_key,text:e.column});
        }.bind(this));                           
      } else {
        this.map_headers = [];
        this.makeToast(`No database headers found.`, 'Alert', 'danger')
      }
    } else
    this.makeToast(`No database headers found.`, 'Alert', 'danger');      
  },
  addFilterCriteria() {
    this.filterCriteria.push({ columns: null, text_value: null });
  },
  deleteFilterCriteria(index) {
    this.filterCriteria.splice(index, 1);
  },
  addConcateColumn() {
    this.concateColumn.push({ columns: [null], name: null });
  },
  deleteConcateColumn(index) {
    this.concateColumn.splice(index, 1);
  },
  addColumns(index) {
    this.concateColumn[index].columns.push(null);
  },
  deleteColumn(index, idx) {
    this.concateColumn[index].columns.splice(idx, 1);
  },
    inArray: function(needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i].value == needle) return i;
    }
    return false;
  },
  selectedHeaders(index) {    
    var is_value = this.inArray(this.map_headers[index].value,this.selectedHeadersShow);
    
    if (is_value !== false) {
      this.selectedHeadersShow.splice(is_value, 1);
    } else {
      this.selectedHeadersShow.push(this.map_headers[index]);
    }    
  },    
  onTagRemoved(tag) {
    this.removed_tags.push(tag.id);
  },
  async save() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.submitStatus = "ERROR";
    } else {      

      if (this.filterCriteria[0].columns === null || this.filterCriteria[0].text_value === null) {
        this.makeToast("Please, fill search criteria","Alert","danger",6000);
        return;
      }
      if (this.selectedHeadersShow.length === 0) {
        this.makeToast("Please, select any columns","Alert","danger",6000);
        return;
      }

      this.formField.id = this.$route.params.id;
      this.formField.removed_tags = this.removed_tags;        
      this.formField.filter_criteria = {
        filter_criteria: this.filterCriteria,
        concate_column: (this.concateColumn || this.concateColumn[0].name !== null ? this.concateColumn : []),
        selected_column:this.selectedHeadersShow.length != 0 ? this.selectedHeadersShow : [],
        match_with:this.formField.type
      };      

      let response = await api.post("admin/export-contact/edit",this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {
        this.makeToast(response.message, "Success", "success");
        this.$router.push({ name: "Export Contact List" });
      } else {
        for (var error in response.errors) {
          this.makeToast(response.errors[error], "Alert", "danger");
        }
      }
    }
  }
}
};
